import React from "react";
import { useSelector } from "react-redux";

export const LoadingScreen = () => {
  const { mostrar } = useSelector((state) => state.loading);
  if(mostrar === false) return;
  return (
    <div class="container">
      <div class="cargando">
        <div class="pelotas"></div>
        <div class="pelotas"></div>
        <div class="pelotas"></div>
        <span class="texto-cargando">Cargando...</span>
      </div>
    </div>
  );
};
